export default {
  title: 'Preferences regarding the use of your personal information',
  modifyButtonLabel: 'Edit',
  accepted: 'Accepted',
  refuse: 'Refused',
};
